import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Spacer } from "@faire/web--source/slate/spacing";
import React from "react";
import { useIsSelfServeHomePage } from "../../hooks/useIsSelfServeHomePage";
import { IconWrapper, IssueTopicCardButtonWrapper, IssueTopicCardInnerWrapper, TypographyWrapper } from "./styles";
export var IssueTopicCard = function IssueTopicCard(_ref) {
  var icon = _ref.icon,
    text = _ref.text,
    linkTo = _ref.linkTo,
    isSelected = _ref.isSelected,
    dataTestId = _ref.dataTestId,
    onClick = _ref.onClick,
    buttonRef = _ref.buttonRef,
    style = _ref.style;
  var isSelfServeHomePage = useIsSelfServeHomePage();
  return /*#__PURE__*/React.createElement(IssueTopicCardButtonWrapper, {
    linkTo: linkTo,
    onClick: onClick,
    "$isSelected": isSelected,
    "data-test-id": dataTestId,
    "$homePage": isSelfServeHomePage,
    buttonRef: buttonRef,
    style: _objectSpread({}, style)
  }, /*#__PURE__*/React.createElement(IssueTopicCardInnerWrapper, null, icon ? (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconWrapper, null, icon), /*#__PURE__*/React.createElement(Spacer, {
    width: "2x"
  }))) : null, /*#__PURE__*/React.createElement(TypographyWrapper, null, text)));
};